import React from 'react';
import { useSelector } from 'react-redux';
import useFetchData from '../../../../hooks/useFetchData';
import { GeneralOverviewPageRenderedComponentProps } from '../../../../layout/general/SimpleGeneralPageWrapper';
import GeneralComponentErrorShield from '../../../general/GeneralComponentErrorShield';
import AifmdOverviewTable from './table/table.component';
import { createSectionByIdSelector } from '../../../../redux/pages/selectors';
import { raptorPlatformIdSelector } from '../../../../redux/raptorPlatform/selectors';
import {
  getReportsListURL,
  getSchemaOverviewMonitorURL,
} from '../../../../routes/endpoints/general.routes';

const AifmdOverview: React.FC<GeneralOverviewPageRenderedComponentProps> = (
  props,
) => {
  const sectionDetails = useSelector(createSectionByIdSelector(props.section));
  const fundTypes = sectionDetails?.fundTypes;
  const selectedRaptorPlatformId = useSelector(raptorPlatformIdSelector);

  const reportsList = useFetchData({
    url: `/${getReportsListURL(fundTypes, undefined, selectedRaptorPlatformId)}`,
    keyName: `${fundTypes}_overview_reports_list_${selectedRaptorPlatformId || ''}`,
    makeFetch: true,
  });
  const overviewData = useFetchData({
    url: `/${getSchemaOverviewMonitorURL(props.positionDate || '', fundTypes, selectedRaptorPlatformId)}`,
    keyName: `${fundTypes}_overview_data_${props.positionDate}_${selectedRaptorPlatformId || ''}`,
    makeFetch: props.positionDate ? true : false,
  });

  return overviewData ? (
    <GeneralComponentErrorShield dataObjects={[overviewData, reportsList]}>
      <AifmdOverviewTable reports={reportsList} inputData={overviewData} />
    </GeneralComponentErrorShield>
  ) : null;
};

export default AifmdOverview;
